import { render, staticRenderFns } from "./ClientDetailRates.vue?vue&type=template&id=0d08080c&scoped=true&"
import script from "./ClientDetailRates.vue?vue&type=script&lang=js&"
export * from "./ClientDetailRates.vue?vue&type=script&lang=js&"
import style0 from "./ClientDetailRates.vue?vue&type=style&index=0&id=0d08080c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d08080c",
  null
  
)

export default component.exports